// extracted by mini-css-extract-plugin
module.exports = {"footer":"UserHistoryDrawerRejectedComments-footer-4986d2e8cb1cb1f0cd4956fd109aa873","loadMore":"UserHistoryDrawerRejectedComments-loadMore-94f7e108e385e26c94d3fc4cb5106073"};